module.exports = __webpack_public_path__ + "02f2a7ab.png";